module.exports = __webpack_public_path__ + "img/Pot3.194e3466.svg";